import { berthApiClient } from '../berthApiClient'

import { getAttachmentFileEndpoint } from './endpoint'

export const getAttachmentFile = (id: number | string): Promise<{ data: Blob }> =>
  berthApiClient.get(getAttachmentFileEndpoint, {
    params: { id },
    responseType: 'blob',
    headers: { 'Content-Type': 'application/octet-stream' },
  })
